import { render, staticRenderFns } from "./DepositTransactionHistory.vue?vue&type=template&id=5c3af3f3"
import script from "./DepositTransactionHistory.vue?vue&type=script&lang=js"
export * from "./DepositTransactionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports